import {
    SET_TEMPORARY_COMPLETION_BADGE
} from '../../../Constants/actionTypes';

export const setTemporaryCompletionBadge = (badge) => ({
  type: SET_TEMPORARY_COMPLETION_BADGE,
  payload: badge,
});
